module.exports = __webpack_public_path__ + "img/ico-grade-black.9427bc6f.svg";